import * as React from 'react';

import { cn } from '../../lib/utils';

// ================================================================= //
//          Reusable Textarea Component for Multi-line Input         //
// ================================================================= //
// A styled, accessible, and reusable textarea component that aligns //
// with the application's design system. It's designed for multi-    //
// line text entry in forms and chat interfaces.                     //
// ================================================================= //


// --- TypeScript Props Interface ---
// Extends the standard HTML textarea attributes to ensure all native
// props are supported (e.g., rows, placeholder, name, etc.).
export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // --- Base Styles ---
          'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background',
          // --- Placeholder Styles ---
          'placeholder:text-muted-foreground',
          // --- Focus & Accessibility Styles ---
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          // --- Disabled State ---
          'disabled:cursor-not-allowed disabled:opacity-50',
          // Allow merging with custom classes
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

// Set a display name for easier debugging in React DevTools.
Textarea.displayName = 'Textarea';

export { Textarea };
